export default {"src":"/_next/static/media/illust-error.5f8c39ee.svg","height":378,"width":342,"blurWidth":0,"blurHeight":0};